import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Comments|Add Comment|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

export type SPCandidateCommentFormLocNames =
	| 'SPCandidateCommentFormFieldErrorTextRequired'
	| 'SPCandidateCommentFormFieldErrorTypeRequired'
	| 'SPCandidateCommentFormFieldLabelText'
	| 'SPCandidateCommentFormFieldLabelType';

export const spCandidateCommentFormLocs: LocDefs<SPCandidateCommentFormLocNames> = {
	SPCandidateCommentFormFieldErrorTextRequired: {
		defaultValue: 'Text is required',
		description: 'Field error saying the text is required.',
		displayPath: `${pathStart}Text Is Required`,
		displayType: 'Error',
		legacyName: 'Core/Candidates.Comments.FieldError.TextRequired',
		...sharedProperties,
	},
	SPCandidateCommentFormFieldErrorTypeRequired: {
		defaultValue: 'Type is required',
		description: 'Field error saying the type is required.',
		displayPath: `${pathStart}Type Is Required`,
		displayType: 'Error',
		legacyName: 'Core/Candidates.Comments.FieldError.TypeRequired',
		...sharedProperties,
	},
	SPCandidateCommentFormFieldLabelText: {
		defaultValue: 'Text',
		description: 'Field label for: Text.',
		displayPath: `${pathStart}Text`,
		displayType: 'Label',
		legacyName: 'Core/Candidates.Comments.FieldLabel.Text',
		...sharedProperties,
	},
	SPCandidateCommentFormFieldLabelType: {
		defaultValue: 'Type',
		description: 'Field label for: Type.',
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'Core/Candidates.Comments.FieldLabel.Type',
		...sharedProperties,
	},
};

export const spCandidateCommentFormLocKeys = MapLocKeys<SPCandidateCommentFormLocNames>(
	spCandidateCommentFormLocs
);

export type SPCandidateCommentFormLocType = LocMap<SPCandidateCommentFormLocNames>;
